/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { BfAppContext, BfPageStore, BfPageStoreLoadParams } from '@tw/tw-runtime';
import { HrDepartmentRestApiService, HrEmployeeRestApiService, HrEmployeeService } from '@tw/clvip-api-gen';

import { AuthDepartmentStoreState } from './type';

export class AuthDepartmentStore extends BfPageStore<AuthDepartmentStoreState> {
  private hrEmployeeRestApiService: HrEmployeeRestApiService;

  constructor() {
    super({
      pluginOptions: {
        devTools: {
          name: 'auth/department'
        }
      }
    });
    const api = BfAppContext.getInstance().getApiService();
    this.hrEmployeeRestApiService = new HrEmployeeRestApiService(api);
  }

  onLoad(param?: BfPageStoreLoadParams): Promise<void> {
    return Promise.resolve();
  }

  async update(departmentId: any) {
    if (!departmentId) {
      return;
    }

    await this.hrEmployeeRestApiService.update({
      id: BfAppContext.getInstance().getUserStore().getState().userInfo.employee?.id,
      departmentId: {
        id: departmentId.id
      }
    });

    BfAppContext.getInstance()
      .getUserStore()
      .setState((state) => {
        state.userInfo.employee.departmentId = departmentId;
        return state;
      });
  }
}
